import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
import { AuthService } from '../services/auth.service';
import { CustomerModel } from '../models/customer.model';
import { GeneralHelper } from '../helpers/general.helper';

@Injectable({
  providedIn: 'root'
})
export class MyProfileRepository {

  private apiUrl: string = environment.apiUrl;

  constructor(
    private httpClient: HttpClient,
    private authService: AuthService,
    private generalHelper: GeneralHelper
  ) { }

  public saveProfile(editProfileForm: CustomerModel): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}/customer/updateCad`, editProfileForm);
  }

  public getUserFacialValidationImage(userId: string) {
    return this.httpClient.get<any>(`${this.apiUrl}/customer/images/latest/${userId}`);
  }

  public generateValidationCode(params: any, captcha: string): Observable<any> {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', captcha);

    return this.httpClient.post<any>(`${this.apiUrl}/customer/create/generatecode-v1`, params, { headers: headers });
  }

  public sendImage(params: any): Observable<any> {
    return this.httpClient.post<any>(`${this.apiUrl}/customer/updateImage`, params);
  }

  public checkValidationCode(params: any) {
    return this.httpClient.post<any>(`${this.apiUrl}/customer/updateCad`, params);
  }

  public deleteProfile(token: string) {
    let headers = new HttpHeaders();
    headers = headers.set('token-recaptcha', token);
    return this.httpClient.delete<any>(`${this.apiUrl}/customer`, { headers: headers });
  }

  public checkToken(token: string, eventId?: string) {
    if (eventId != null) {
      return this.httpClient.get<any>(`${this.apiUrl}/customer/checkToken/${token}?eventId=${eventId}`);
    } else {
      return this.httpClient.get<any>(`${this.apiUrl}/customer/checkToken/${token}`);
    }
  }

  public checkCustomerRegisterWithCpf(doc: any) {
    return this.httpClient.get<any>(`${this.apiUrl}/customer/listByFilter/public?doc=${doc}`);
  }

  public findByDoc(doc: any) {
    return this.httpClient.get<any>(`${this.apiUrl}/customer/${doc}`);
  }

  public sendFaceSignCallback(encodedImage: string) {
    return this.httpClient.post<any>(`${this.apiUrl}/v2/facesign/encoded-callback`, { encodedImage });
  }

}
